import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Modalizer from 'components/modalizer/modalizer'
import NearpodPicker from 'components/nearpod_picker/nearpod_picker'

class Picker extends PureComponent {

	constructor(props) {
		super(props)
		this.acceptedFiles = this.acceptedFiles.bind(this)
		this.onFilesPicked = this.onFilesPicked.bind(this)
	}

	onFilesPicked(file) {
		this.props.onFilesPicked(file, this.acceptedFiles())
	}

	acceptedFiles() {
		return this.props.accepted_files[this.props.pickerType]
	}

	render() {
		return (
			<Modalizer width='570px' height={this.props.pickerType!=='web'?'564px':''} nopadding={true} closeAction={this.props.closeHandler}>
				<NearpodPicker
					onFilesPicked={this.onFilesPicked}
					closeHandler={this.props.closeHandler}
					pickerType={this.props.pickerType}
					accept={this.acceptedFiles()}
					multiselect={false}
					onFileError={this.props.onFileError}
					googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
				/>
			</Modalizer>
		)
	}
}

Picker.propTypes = {
	modalName: PropTypes.string,
	multiselect: PropTypes.bool,
	accepted_files: PropTypes.object,
	googleDrivePickerOrigin: PropTypes.string,
}

Picker.defaultProps = {
	modalName: '',
	accepted_files: {
		audio: ['audio'],
		audio_recorder: ['audio'],
		gif: ['gif'],
		image: ['image'],
		video: ['video'],
		pdf: ['pdf'],
		web: ['web'],
	},
	multiselect: false,
	googleDrivePickerOrigin: null,
}

export default Picker
